import { BulkCandidatesWizardContainer } from '@/features/jobs/job-bulk-candidates/BulkCandidatesWizardContainer';

/** EU-551 — wizard de movimentação em massa (porta de entrada: Gestão de vaga). */
export default function JobMoveCandidatesPage() {
  return <BulkCandidatesWizardContainer variant="move" />;
}
